<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="row" v-if="row.item.status != 'New'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:started_date" slot-scope="row">
                                {{row.item.started_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                             <template slot="gofix_table:expiry_date" slot-scope="row">
                                {{row.item.expiry_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Permit To Work" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown 
                            label="PTW Type" 
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            :reduce="option => option.reference_value_text"
                            v-model="modals.add.data.type" 
                            :options="modals.add.options.ptw_types">
                        </gofix-form-dropdown>
                        <dropdown-projects 
                            required
                            show-icon-required
                            v-model="modals.add.data.project">
                        </dropdown-projects>
                        <dropdown-locations 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.equipment">
                        </dropdown-locations>
                        <gofix-form-input-textarea 
                            label="Description of Work" 
                            v-model="modals.add.data.description">
                        </gofix-form-input-textarea>

                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-number 
                                    label="Number of Supervisor" 
                                    v-model="modals.add.data.number_of_supervisor" 
                                    :integer-limit="4" 
                                    :include-thousands-separator="false" 
                                    :rows="5"
                                    :allowDecimal="false" class="gofixInputNoMinWidth">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-number 
                                    label="Number of Workmen" 
                                    v-model="modals.add.data.number_of_workmen" 
                                    :integer-limit="4" 
                                    :include-thousands-separator="false" 
                                    :allowDecimal="false" class="gofixInputNoMinWidth">
                                </gofix-form-input-number>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-date
                                    :minDate="new Date()"
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.started_date"
                                    label="Start Date">
                                </gofix-form-input-date>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="Start Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.started_time">
                                </gofix-form-input-time>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-date
                                    :minDate="new Date()" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.expiry_date"
                                    label="End Date">
                                </gofix-form-input-date>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="End Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.expiry_time">
                                </gofix-form-input-time>
                            </b-col>
                        </b-row>
                        <gofix-form-dropdown
                            label="Contractor Checklist"
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            :required="true"
                            :show-icon-required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="modals.add.data.checklist_template_id"
                            :options="modals.add.options.checklist_templates">
                        </gofix-form-dropdown>
                        <dropdown-user-duties 
                            label="Assessor"
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            role-name="Safety Assessor"
                            :safetyOnlyFM="true"
                            v-model="modals.add.data.assessor">
                        </dropdown-user-duties>
                        <gofix-form-dropdown
                            v-if="modals.add.data.type && modals.add.data.type == 'WAH'"
                            label="Assessor Checklist for Evaluation"
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            :required="true"
                            :show-icon-required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="modals.add.data.assessor_checklist_for_evaluation_id"
                            :options="modals.add.options.assessor_checklists">
                        </gofix-form-dropdown>
                        <dropdown-user-duties 
                            label="Project Manager"
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            role-name="Project Manager"
                            :safetyOnlyFM="true"
                            v-model="modals.add.data.project_manager">
                        </dropdown-user-duties>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
import DropdownProjects from '../elements/DropdownProjects.vue'
import DropdownLocations from '../elements/DropdownLocations.vue'
import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
export default {
    name: 'permit-to-work-listing',
    components: {
        DropdownProjects,
        DropdownLocations,
        DropdownUserDuties
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['permit_to_work_listing']));
        return {
            tableConfig:{
                name: 'permit-to-work-listing',
                controls:{
                    // create: this.$checkRole(this.$accessModule.permit_to_work, 'create'),
                    create: false,
                    delete: this.$checkRole(this.$accessModule.permit_to_work, 'delete'),
                    tableImport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Pending Approval', text: 'Pending Approval'},
                            {value: 'Approved ', text: 'Approved '},
                            {value: 'Rejected', text: 'Rejected'},
                            {value: 'Expired', text: 'Expired'},
                            {value: 'Closed', text: 'Closed'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    },
                    type: {
                        value: [
                            {value: 'WAH', text: 'WAH'},
                            {value: 'Lifting Operations', text: 'Lifting Operations'},
                            {value: 'Hot Works', text: 'Hot Works'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        checklist_template_id: null,
                        assessor_checklist_for_evaluation_id: null,
                        type: null,
                        description: null,
                        number_of_supervisor: null,
                        number_of_workmen: null,
                        started_date: null,
                        expiry_date: null,
                        project_manager: null,
                        assessor: null,
                        started_time: null,
                        expiry_time: null,
                    },
                    options: {
                        scontracts: [],
                        equipments: [],
                        users: [],
                        checklist_templates: [],
                        assessor_checklists: [],
                        ptw_types: []
                    }
                }
            },
            pagesEquipment: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            timer: {
                equipment: null,
                scontracts: null,
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    watch: {
        "modals.add.data.type": function(val) {
            this.modals.add.options.assessor_checklists = [];
            this.modals.add.data.checklist_template_id = this.modals.add.data.assessor_checklist_for_evaluation_id = null;
            this.getChecklistTemplates();
            if(val && val == 'WAH') {
                this.getChecklistTemplates('PTW WAH Evaluation');
            }
        },
        "modals.add.data.project": function() {
            this.getChecklistTemplates();
            if(this.modals.add.data.type && this.modals.add.data.type == 'WAH') {
                this.getChecklistTemplates('PTW WAH Evaluation');
            }
        }
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getPermitToWorkItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of users", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
           this.$router.push(`/v2/permit-to-work/${item.id}`)
        },
        newItem() {
            this.getPTWType();
            this.modals.add.data = {
                project: null,
                equipment: null,
                checklist_template_id: null,
                assessor_checklist_for_evaluation_id: null,
                type: null,
                description: null,
                number_of_supervisor: null,
                number_of_workmen: null,
                started_date: null,
                expiry_date: null,
                project_manager: null,
                assessor: null,
                started_time: null,
                expiry_time: null,
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deletePermitToWorkItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'permit_to_work'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems(tableRequest) {
            let request = JSON.parse(JSON.stringify(tableRequest));
            request.limit = -1;
            this.$store.dispatch('SafetyAppController/exportPermitToWork', request)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'PermitToWork.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        },
        async getChecklistTemplates(type = null){
            if(!this.modals.add.data.type || !this.modals.add.data.project) {
                this.modals.add.options.checklist_templates = [];
                return;
            }
            this.$store.dispatch( 'v2CheckListTemplateController/getListCheckListTemplate', {
                filter: {
                    contract_id: this.modals.add.data.project.client_contract_id,
                    type: type ? type: `PTW ${this.modals.add.data.type}`
                },
                limit: -1,
                page: 1,
                // isCMS: 1
            })
            .then(response => {
                if(type && type == 'PTW WAH Evaluation') {
                    this.modals.add.options.assessor_checklists = response.data.data.items;
                    if(this.modals.add.options.assessor_checklists.length) {
                        this.modals.add.data.assessor_checklist_for_evaluation_id = this.modals.add.options.assessor_checklists[0].id;
                    }
                    return;
                }

                this.modals.add.options.checklist_templates = response.data.data.items;
                if(this.modals.add.options.checklist_templates.length) {
                    if(this.modals.add.data.type == 'WAH') {
                        let arr_tmp = this.modals.add.options.checklist_templates.filter(ct => ct.type.includes('PTW WAH'));
                        if(arr_tmp.length) {
                            this.modals.add.data.checklist_template_id = arr_tmp[0].id;
                        }
                        return;
                    }
                    this.modals.add.data.checklist_template_id = this.modals.add.options.checklist_templates[0].id;
                }
            })
            .catch(err => {
                this.modals.add.options.checklist_templates = [];
            });
        },
        getPTWType(){
            let filter = {reference_type: "Safety Type Permit To Work"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.ptw_types = response.items;
                })
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                const validate_fields = [
                    { key: 'type', name: 'PTW Type'},
                    { key: 'project', name: 'Project'},
                    { key: 'equipment', name: 'Location'},
                    { key: 'checklist_template_id', name: 'Contractor Checklist'},
                    { key: 'started_date', name: 'Start Date'},
                    { key: 'expiry_date', name: 'End Date'},
                    { key: 'started_time', name: 'Start Time'},
                    { key: 'expiry_time', name: 'End Time'},
                ]

                const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                if(is_validate) return

                if(this.modals.add.data.type == 'WAH' && !this.modals.add.data.assessor_checklist_for_evaluation_id) {
                    return this.$alertNotification("Assessor Checklist for Evaluation is required", "danger");
                }

                if(moment(this.modals.add.data.started_date).isAfter(moment(this.modals.add.data.expiry_date))) {
                    flagDateCheck = true;
                    message = 'End Date must be greater than Start Date';
                }

                const daysDiff = moment(this.modals.add.data.expiry_date).diff(moment(this.modals.add.data.started_date), 'days');
                if(daysDiff > 6) {
                    return this.$alertNotification("Start Date and End Date cannot be more than 6 days apart", "danger");
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    // client_contract_id: this.ClientContractID.id,
                    checklist_template_id: this.modals.add.data.checklist_template_id,
                    assessor_checklist_for_evaluation_id: this.modals.add.data.assessor_checklist_for_evaluation_id,
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.name,
                    // equipment_id: this.modals.add.data.equipment.equipment_id,
                    // equipment_lift_number: this.modals.add.data.equipment.equipment_lift_number,
                    equipment_type: this.modals.add.data.equipment.equipment_type,
                    started_date: this.modals.add.data.started_date ? moment(this.modals.add.data.started_date).format('YYYY-MM-DD') + ' ' + (this.modals.add.data.started_time + ':00') : null,
                    expiry_date: this.modals.add.data.expiry_date ? moment(this.modals.add.data.expiry_date).format('YYYY-MM-DD') + ' ' + (this.modals.add.data.expiry_time + ':00') : null,
                    type: this.modals.add.data.type,
                    description: this.modals.add.data.description,
                    number_of_supervisor: this.modals.add.data.number_of_supervisor,
                    number_of_workmen: this.modals.add.data.number_of_workmen,
                    project_manager_id: this.modals.add.data.project_manager ? this.modals.add.data.project_manager.user_id : null,
                    assesor_id: this.modals.add.data.assessor ? this.modals.add.data.assessor.user_id : null,
                };
                
                this.$store.dispatch("SafetyAppController/createPermitToWorkItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/permit-to-work/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'permit_to_work'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        }
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
</style>